import { render } from "./ViewUser.vue?vue&type=template&id=6bddb034&scoped=true&ts=true"
import script from "./ViewUser.vue?vue&type=script&lang=ts"
export * from "./ViewUser.vue?vue&type=script&lang=ts"

import "./ViewUser.vue?vue&type=style&index=0&id=6bddb034&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bddb034"]])

export default __exports__